/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export type TableCellBalanceType = 'default' | 'negative' | 'positive';

export const TableCellBalanceValueStyled = styled.div.attrs({
    className: 'table__tooltip-text',
})<{ type: TableCellBalanceType }>`
    ${fonts.textMain};

    ${props => ({
        'default': `color: ${colors.textColor};`,
        'negative': `color: ${colors.tableCellTextColorDanger};`,
        'positive': `color: ${colors.tableCellTextColorSuccess};`,
    }[props.type])}

    .currency {
        ${fonts.textMain};
        color: ${colors.tableCellTextColorSecondary};
    }
`;

export const TableCellBalanceDateStyled = styled.div.attrs({
    className: 'table__tooltip-text',
})`
    ${fonts.textSmall};
    color: ${colors.tableCellTextColorSecondary};
`;
